import React, { useState } from "react";
import { GlobalStyle } from 'styled/global';
import Router from 'routes';
import EnviromentForm from "EnviromentForm";

const isDevelop = window.location.href.split('dev.whizr').length > 1

function App() {
  const [init, setInit] = useState(false)

  return (
    <>
      <GlobalStyle />
      {
        isDevelop
          ? (!init ? <EnviromentForm onAuthorize={() => setInit(true)} /> : <Router />)
          : <Router />
      }
    </>
  );
};

export default App;
